// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1NXlQ","label":"Section_label__Mjy16","contentWrap":"Section_contentWrap__8EjdQ","footer":"Section_footer__1RUQ4","footerInner":"Section_footerInner__2Ey-q"};